import { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import LogisticsTimeline from "./LogisticsTimeline";
import "./OrderDetailsCard.css";
import { getLogisticsShipmentDetails } from "../../../../config/Services";

/* ── Inline SVGs ─────────────────────────────────────────────────── */
const XIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M18 6 6 18" />
    <path d="m6 6 12 12" />
  </svg>
);
const UserIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);
const PackageIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z" />
    <path d="M12 22V12" />
    <polyline points="3.29 7 12 12 20.71 7" />
    <path d="m7.5 4.27 9 5.15" />
  </svg>
);
const MapPinIcon = ({ size = 14, color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    style={{ flexShrink: 0 }}
  >
    <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);
const ClockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M12 6v6l4 2" />
    <circle cx="12" cy="12" r="10" />
  </svg>
);
const PhoneIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384" />
  </svg>
);
const TrackIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);
const DownloadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M12 15V3" />
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <path d="m7 10 5 5 5-5" />
  </svg>
);
const AlertIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="12" x2="12" y1="8" y2="12" />
    <line x1="12" x2="12.01" y1="16" y2="16" />
  </svg>
);

/* ── Status badge style helper ───────────────────────────────────── */
const getStatusStyle = (status) => {
  const s = (status || "").toUpperCase();
  if (s === "PENDING") return { bg: "#dbeafe", color: "#1d4ed8" };
  if (["ASSIGNED", "PICKED_UP", "RIDER_REACHED_PICKUP"].includes(s))
    return { bg: "#dbeafe", color: "#1d4ed8" };
  if (["IN_TRANSIT", "SHIPPED"].includes(s)) return { bg: "#fce7f3", color: "#be185d" };
  if (s === "DELIVERED") return { bg: "#d1fae5", color: "#047857" };
  if (s === "CANCELLED") return { bg: "#ffe4e6", color: "#be123c" };
  return { bg: "#f1f5f9", color: "#475569" };
};

/* ── Field sub-component ─────────────────────────────────────────── */
const Field = ({ label, children }) => (
  <div className="odm___field">
    <p className="odm___field-label">{label}</p>
    <div className="odm___field-value">{children}</div>
  </div>
);

/* ── Main component ──────────────────────────────────────────────── */
export default function OrderDetailsModal({
  open,
  onClose,
  shipmentId,
  showSnackbar,
  comingSoonAlert,
}) {
  const [loader, setLoader] = useState(false);
  const [shipmentData, setShipmentData] = useState("");

  const getShipmentDetails = async () => {
    try {
      if (loader) return;
      setLoader(true);

      const response = await getLogisticsShipmentDetails(shipmentId);
      if (response?.data?.data?.es) {
        showSnackbar("Something went wrong", "error");
        setLoader(false);
        return;
      }

      setShipmentData(response?.data?.data?.shipment || {});
      setLoader(false);
    } catch (err) {
      showSnackbar("Something went wrong", "error");
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (shipmentId) getShipmentDetails(shipmentId);
  }, [shipmentId]);

  if (!open) return null;

  const statusStyle = getStatusStyle(shipmentData?.shipmentStatus);

  return ReactDOM.createPortal(
    <>
      {/* Backdrop */}
      <div className="odm___backdrop" onClick={onClose} />

      {/* Drawer */}
      <div className="odm___drawer">
        {/* ── Header ── */}
        <div className="odm___drawer-header">
          <h2 className="odm___drawer-title">Shipment Details</h2>
          <button className="odm___close-btn" onClick={onClose} aria-label="Close">
            <XIcon />
          </button>
        </div>

        {/* ── Scrollable body ── */}
        <div className="odm___drawer-body">
          {/* Meta row */}
          <div className="odm___meta-row">
            <span className="odm___meta-shipment-id">{shipmentData?.shipmentId || "N/A"}</span>
            <span className="odm___meta-order-id">{shipmentData?.orderId || "N/A"}</span>
            <span
              className="odm___meta-status"
              style={{ background: statusStyle.bg, color: statusStyle.color }}
            >
              {shipmentData?.shipmentStatus || shipmentData?.logisticsOrderStatus || "N/A"}
            </span>

            <div className="odm___meta-divider" />

            <div className="odm___meta-provider">
              <PackageIcon />
              <span>{shipmentData?.logisticsProvider || "N/A"}</span>
            </div>

            <div className="odm___meta-vehicle">
              Vehicle: <strong>{shipmentData?.riderVehicleType || "N/A"}</strong>
            </div>

            {shipmentData?.totalDistance && (
              <div className="odm___meta-vehicle">
                Total Distance: <strong>{shipmentData.totalDistance}</strong>
              </div>
            )}

            <div className="odm___meta-right">
              {shipmentData?.source && (
                <span className="odm___meta-source">{shipmentData.source}</span>
              )}
              {shipmentData?.totalDuration && (
                <div className="odm___meta-duration">
                  <ClockIcon />
                  <span>
                    Total Duration{" "}
                    <strong className="odm___duration-highlight">
                      {shipmentData.totalDuration}
                    </strong>
                  </span>
                </div>
              )}
            </div>
          </div>

          {/* ── Detail cards ── */}
          <div className="odm___cards-grid">
            {/* Delivery Partner */}
            <div className="odm___detail-card">
              <div className="odm___card-heading">
                <UserIcon />
                <h3 className="odm___card-title">Delivery Partner Details</h3>
              </div>
              <div className="odm___card-fields">
                <Field label="Partner Name">{shipmentData?.deliveryPartner?.name || "N/A"}</Field>
                <Field label="Phone No.">
                  {shipmentData?.deliveryPartner?.contactNumber || "N/A"}
                </Field>
                <Field label="Partner ID">
                  {shipmentData?.deliveryPartner?.riderId ||
                    shipmentData?.deliveryPartner?.id ||
                    "N/A"}
                </Field>
                <Field label="Vehicle">
                  <div className="odm___vehicle-row">
                    <span>{shipmentData?.deliveryPartner?.vehicleType || "N/A"}</span>
                    <span className="odm___vehicle-number">
                      {shipmentData?.deliveryPartner?.vehicleNumber || "N/A"}
                    </span>
                  </div>
                </Field>
              </div>
            </div>

            {/* Customer */}
            <div className="odm___detail-card">
              <div className="odm___card-heading">
                <PackageIcon />
                <h3 className="odm___card-title">Customer Details</h3>
              </div>
              <div className="odm___card-fields">
                <Field label="Order ID">{shipmentData?.orderId || "N/A"}</Field>
                <Field label="Customer Name">{shipmentData?.customer?.name || "N/A"}</Field>
                <Field label="Phone No.">{shipmentData?.customer?.contactNumber || "N/A"}</Field>
                <Field label="Delivery Location">
                  <div className="odm___location-row">
                    <MapPinIcon size={14} color="#f43f5e" />
                    <span>{shipmentData?.drop || "N/A"}</span>
                  </div>
                </Field>
              </div>
            </div>
          </div>

          {/* ── Action buttons ── */}
          <div className="odm___actions-row">
            <div className="odm___action-btns">
              <button className="odm___btn odm___btn-blue" onClick={(e) => comingSoonAlert(e)}>
                <PhoneIcon /> Contact Delivery Partner
              </button>
              <button
                className="odm___btn odm___btn-slate"
                disabled={!shipmentData?.trackingLink}
                onClick={() => {
                  let url = shipmentData?.trackingLink;
                  if (!url) return;
                  if (!/^https?:\/\//i.test(url)) url = `https://${url}`;
                  window.open(url, "_blank", "noopener,noreferrer");
                }}
              >
                <TrackIcon /> Live Tracking
              </button>
              <button className="odm___btn odm___btn-slate" onClick={(e) => comingSoonAlert(e)}>
                <DownloadIcon /> Download Invoice
              </button>
              <button className="odm___btn odm___btn-rose" onClick={(e) => comingSoonAlert(e)}>
                <AlertIcon /> Report an Issue
              </button>
            </div>
            {shipmentData?.expectedArrivalTime && (
              <div className="odm___expected-arrival">
                Expected Arrival{" "}
                <strong className="odm___arrival-time">{shipmentData.expectedArrivalTime}</strong>
              </div>
            )}
          </div>

          {/* ── Timeline ── */}
          <div className="odm___timeline-card">
            <h3 className="odm___timeline-title">Delivery Timeline</h3>
            {shipmentData?.timeline ? (
              <LogisticsTimeline timeline={shipmentData?.timeline || []} />
            ) : (
              <div className="odm___empty">No Data Found</div>
            )}
          </div>
        </div>
      </div>
    </>,
    document.body
  );
}
